module.exports = __webpack_public_path__ + "img/05.44b47005.png";